import {
  afterNextRender,
  AfterRenderPhase,
  Component,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  ViewChildren,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize, map, shareReplay } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { DividendVipService } from 'src/app/pages/dividend-vip/dividend-vip.service';
import { NotificationService } from 'src/app/pages/notification-center/notification.service';
import { CardCenterService } from 'src/app/pages/voucher-center/card-center/card-center.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { NotificationCenterApi } from 'src/app/shared/apis/notification-center.api';
import { PaginatorState } from 'src/app/shared/components/paginator/paginator.module';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { RespActivityDetail } from 'src/app/shared/interfaces/bonus.interface';
import {
  NoticeContent,
  NoticeTypeCounts,
  QueryNoticeParams,
} from 'src/app/shared/interfaces/notification-center.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { RightAsideService } from '../right-aside.service';
export const NotiTypeNameMap: { [key: string]: string } = {
  Activity: 'activities_noti',
  System: 'sys_noti',
  Information: 'news_noti',
  Transaction: 'trade_noti',
};

@UntilDestroy()
@Component({
  selector: 'app-right-combine-popup',
  templateUrl: './right-combine-popup.component.html',
  styleUrls: ['./right-combine-popup.component.scss'],
})
export class RightCombinePopupComponent implements OnInit, OnDestroy {
  private readonly injector = inject(Injector);
  private _removeListeners: (() => void)[] = [];

  tab_num = 0;
  selected = 0;
  SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };
  constructor(
    private dividendVipService: DividendVipService,
    private appService: AppService,
    private router: Router,
    private bonusApi: BonusApi,
    private cardCenterService: CardCenterService,
    private toast: ToastService,
    private localService: LocaleService,
    private layout: LayoutService,
    private rightAsideService: RightAsideService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private notificationApi: NotificationCenterApi,
  ) {}

  /** 通知弹窗导航 */
  noticeNavList = [
    { title: this.localService.getValue('notification'), msg: 0 },
    { title: this.localService.getValue('promote'), msg: 0 },
    { title: this.localService.getValue('login_jop_04'), msg: 0 },
    { title: this.localService.getValue('race_text'), msg: 0 },
  ];
  /**通知类型tab菜单 */
  notificationNavList = [
    { title: this.localService.getValue('all_noti'), msg: 0, value: '' },
    { title: this.localService.getValue('activities_noti'), msg: 0, value: 'Activity' },
    { title: this.localService.getValue('sys_noti'), msg: 0, value: 'System' },
    { title: this.localService.getValue('news_noti'), msg: 0, value: 'Information' },
    { title: this.localService.getValue('trade_noti'), msg: 0, value: 'Transaction' },
  ];
  /**通知顶部工具菜单 */
  iconLists: any[] = [
    /**隐藏已读 */
    // { iconName: 'icon-hide', text: 'hide_read', active: false },
    /**所有 */
    { iconName: 'icon-read', text: 'read_all', active: false },
    /**清除已读 */
    { iconName: 'icon-clean', text: 'clear_all_01', active: false },
  ];
  /** 是否隐藏已读短信 */
  data: any = {
    isHiddenReadedMsg: false,
  };
  /** 站内信类型 */
  noticeType: string = '';
  /** 是否已读 */
  isReaded!: boolean | undefined;
  /** 点击这里 */
  click: string = this.localService.getValue('clcik_here');

  /** 选择活动的下标 0:系统通知: 1:优惠 2:奖励 3:竞赛*/
  selectedNoticeIndex: number = 0;

  /** 通知弹窗loading */
  noticePupupLoading: boolean = false;

  /** 所有活动 */
  activities: RespActivityDetail[] = [];

  /** 所有消息通知 */
  allNotice: Array<NoticeContent> = [];

  /** 卡券 */
  cardsList: any = [];

  /** 卡券兑换分页面 */
  paginator: PaginatorState = { page: 1, pageSize: 16, total: 0 };

  /** 站内信分页面 */
  notiPaginator: PaginatorState = { page: 1, pageSize: 10, total: 0 };

  /** 领取 卡券loading */
  cardLoading: boolean = false;

  /** 当前卡券id */
  currentCardId!: number;

  /** 用戶資訊 */
  userInfo!: AccountInforData;

  /** id号 */
  idList!: number[];

  /** 是否登陆状态 */
  logined!: boolean;
  isH5!: boolean;

  noticeLoading = true;

  /** 一键领取loading */
  collectAllLoading: boolean = false;

  /** 是否开启 sticky按钮 */
  btnSticky!: boolean;

  /** 全部通知：0 活动通知:1 系统消息:2 平台咨询:3 交易通知:4*/
  selectNoticeItemIndex = 0;
  /**是否已经全部已读 */
  isReadedAll: boolean = false;
  isShowBoard: boolean = false;
  /**是否已经全部删除 */
  isDeleteAll: boolean = false;
  ngOnInit(): void {
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe((e: boolean) => (this.isH5 = e));
    this.notificationService.isDeleteAll$.pipe(untilDestroyed(this)).subscribe((e: boolean) => (this.isDeleteAll = e));
    this.notificationService.isReadedAll$.pipe(untilDestroyed(this)).subscribe((e: boolean) => (this.isReadedAll = e));
    const combineActiveIndex = this.rightAsideService.getCombinePopupIndex;
    if (combineActiveIndex) {
      this.selectedNoticeIndex = combineActiveIndex;
    }
    this.onInitNoticePopup();

    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(x => {
      this.userInfo = x ?? ({} as AccountInforData);
      this.logined = !!x;
    });
    //默认获取所有通知 （包括：已读 和 未读）
    this.appService.noticeCounts$.pipe(untilDestroyed(this)).subscribe((e: NoticeTypeCounts) => {
      //设置顶部一级菜单【0】：系统通知数量
      this.noticeNavList[0].msg = e?.All || 0;
      //通知信息类型分类,设置消息数量
      this.notificationNavList[0].msg = e?.All || 0;
      this.notificationNavList[1].msg = e?.Activity || 0;
      this.notificationNavList[2].msg = e?.System || 0;
      this.notificationNavList[3].msg = e?.Information || 0;
      this.notificationNavList[4].msg = e?.Transaction || 0;

      // 当top-bar和推送事件发生的时候，重新调用一下数据
      this.notificationService.reLoadData$.pipe(untilDestroyed(this)).subscribe((e: boolean) => {
        if (e) {
          this.getNotificationData(false, true);
        }
      });
    });
    this.cardCenterService.bounsCount$.pipe(untilDestroyed(this)).subscribe(v => {
      this.noticeNavList[2].msg = v || 0;
      if (this.selectedNoticeIndex === 2) {
        this.getCardlists();
      }
    });
  }

  /**
   * 手势拖动
   *
   * @param eType
   */
  swipe(eType: string) {
    // 在这里处理滑动事件的逻辑
    if (eType === this.SWIPE_ACTION.LEFT && this.selectNoticeItemIndex > 0) {
      this.selectNoticeItemIndex--;
    } else if (eType === this.SWIPE_ACTION.RIGHT && this.selectNoticeItemIndex < this.tab_num) {
      this.selectNoticeItemIndex++;
    }
    const currentItem = this.notificationNavList[this.selectNoticeItemIndex];
    this.onSelectNoticeTypeMenuItem(currentItem, this.selectNoticeItemIndex);
  }

  ngOnDestroy(): void {
    this.layout.rightCombinePupup$.next(false);

    // 清除 event listeners
    this._removeListeners.forEach(fn => fn());
    this._removeListeners = [];
    this.notificationService.getNoticeCounts();
  }

  /** 初始化 通知弹窗 */
  onInitNoticePopup() {
    switch (this.selectedNoticeIndex) {
      case 0: //系统通知数据初始化
        this.getNotificationData(false, true);
        break;
      case 1:
        this.getActivitiesList();
        break;
      case 2:
        this.getCardlists();
        break;
      case 3:
        break;
      default:
        return;
    }
    this.rightAsideService.setCombinePopupIndex = this.selectedNoticeIndex;
  }

  /** 获取活动列表 */
  @ViewChildren('activiyImgs') activiyImgs!: any;
  getActivitiesList() {
    this.noticePupupLoading = true;
    this.dividendVipService.getActivitiesList({ equipment: 'Web' }).subscribe((data: any) => {
      this.noticePupupLoading = false;
      this.activities = data?.list[0]?.list || [];
    });
  }

  /**获取站内信数据
   * @param showMore 是否已读
   */
  getNotificationData(showMore: boolean = false, reload: boolean = false) {
    if (
      this.rightAsideService.allNoticeCache.list.length &&
      this.rightAsideService.allNoticeCache.list.length == this.rightAsideService.allNoticeCache.total &&
      !reload
    ) {
      this.allNotice = this.rightAsideService.allNoticeCache.list;
      this.notiPaginator.total = this.rightAsideService.allNoticeCache.total;
      return;
    }

    this.noticeLoading = true;
    const params = {
      page: this.notiPaginator.page,
      pageSize: this.notiPaginator.pageSize,
      noticeType: '',
    };
    this.getNoticeMsg(showMore, params);
  }

  /**
   * 获取站内信通知数据
   *
   * @param showMore 已读
   * @param params
   */
  getNoticeMsg(showMore: boolean = false, params: QueryNoticeParams) {
    this.notificationService
      .getQueryNotice(params)
      .pipe(
        untilDestroyed(this),
        map(data => {
          if (data.total && data.list.length > 0) {
            data.list.map((item: NoticeContent) => {
              item.name = NotiTypeNameMap[item.noticeType];
              if (item.businessType !== 'WithdrawalRejected' && item.content && item.content.includes('<a')) {
                item.content = item.content
                  .replace(/<a/g, '<div class="special-tag"><span class="click">' + this.click + '</span><a')
                  .replace(/<\/a>/g, '</a></div>');
              }
            });
            return data;
          }
        }),
      )
      .subscribe(data => {
        this.noticeLoading = false;
        if (data) {
          this.rightAsideService.allNoticeCache.total = data.total;
          if (showMore) {
            this.allNotice.push(...data.list);
          } else {
            this.allNotice = data.list;
          }
          this.rightAsideService.allNoticeCache.list = this.allNotice;
          this.notiPaginator.total = data.total;
          //更新 订阅是否已经全部删除数据
          if (this.allNotice.length === 0) {
            this.notificationService.isDeleteAll$.next(true);
          } else {
            this.notificationService.isDeleteAll$.next(false);
          }
          //更新 订阅是否已经全部阅读
          const isReadedList = this.allNotice.filter(msg => msg.isReaded === false);
          if (isReadedList.length === 0) {
            this.notificationService.isReadedAll$.next(true);
          } else {
            this.notificationService.isReadedAll$.next(false);
          }
        }

        afterNextRender(
          () => {
            // 監聽 kyc page click
            const els = document.querySelectorAll('.userCenter-kyc');
            els.forEach(el => {
              el.addEventListener('click', this._onKycPageClick);
              // push cleanup function
              this._removeListeners.push(() => el.removeEventListener('click', this._onKycPageClick));
            });
          },
          { phase: AfterRenderPhase.Read, injector: this.injector },
        );
      });
  }

  onPan(event: HammerInput) {
    console.log('Pan event:', event);
  }

  /**
   * 根据通知类型显示logo
   *
   * @param noticeType 通知类型
   * @returns
   */
  getImageUrl(noticeType: string): string {
    switch (noticeType) {
      case 'System':
        return 'assets/svg/sys_noti.svg';
      case 'Transaction':
        return 'assets/svg/trade_noti.svg';
      case 'Activity':
        return 'assets/svg/activities_noti.svg';
      case 'Information':
        return 'assets/svg/news_noti.svg';
      default:
        return 'assets/svg/all_noti.svg'; // Default image for unrecognized noticeType
    }
  }
  /**
   * 是否已读
   *
   * @param item
   * @param index
   */
  onReadMsgCall(item: NoticeContent, index: number) {
    if (item.isReaded === true) {
      return;
    }
    //设置为已读
    item.isReaded = true;
    this.noticePupupLoading = true;
    const params = {
      idList: [item.id],
    };
    this.refreshReadNotice(params, false);
  }

  /**
   * 刷新 设置已读
   *
   * @param params
   * @param tips
   */
  refreshReadNotice(params: any, tips: boolean = false) {
    if (tips) {
      const params = {
        noticeType: this.noticeType,
      };
      this.notificationApi
        .onReadAll(params)
        .pipe(
          finalize(() => {
            this.noticeLoading = false;
            this.loadData();
          }),
        )
        .subscribe(data => {
          if (data) {
            this.toast.show({ message: this.localService.getValue('mess_allread'), type: 'success' });
            this.notificationService.getNoticeCounts();
            if (this.noticeType.length === 0) {
              this.notificationService.isReadedAll$.next(data);
            }
          } else {
            this.toast.show({ message: this.localService.getValue('mess_read_f'), type: 'fail' });
          }
        });
    } else {
      this.notificationService
        .readNotice(params)
        .pipe(
          finalize(() => {
            this.noticePupupLoading = false;
          }),
        )
        .subscribe(data => {
          if (data) {
            this.notificationService.getNoticeCounts();
          }
        });
    }
  }

  /**
   * 标记已经读取
   *
   * @returns
   */
  onReadMsg() {
    // 通知全部已读后 判断后 不请求
    if (this.isReadedAll) {
      this.toast.show({ message: this.localService.getValue('noti_allread'), type: 'fail' });
      return;
    }
    this.refreshReadNotice([], true);
  }

  /**
   * 前往活动详情
   *
   * @param item 活动数据
   */
  onRedirectActivityDetail(item: RespActivityDetail) {
    this.router.navigate([this.appService.languageCode, 'promotions', 'offer', item.activitiesNo]);
    this.closeRightAside();
  }

  closeRightAside() {
    this.layout.rightCombinePupup$.next(false);
  }

  /** 获取未领取的卡券 */
  getCardlists() {
    this.noticePupupLoading = true;
    const param = {
      pageIndex: 1,
      pageSize: 999,
      status: 'Unclaimed',
      ascSort: false,
    };

    this.bonusApi
      .getBonusDetail(param)
      .pipe(shareReplay(1))
      .subscribe(data => {
        this.noticePupupLoading = false;
        this.collectAllLoading = false;
        this.cardLoading = false;
        this.cardsList = data?.list || [];
      });
  }

  /**
   * 领取卡券
   *
   * @param id
   */
  onClickOpenConfirmPopup(id: number) {
    this.cardLoading = true;
    this.currentCardId = id;
    this.bonusApi
      .getReceiveBackwater({ bonusId: id })
      .pipe(map(v => v?.data))
      .subscribe(data => {
        if (data) {
          this.toast.show({ message: this.localService.getValue('hl_conf_s'), type: 'success' });
          this.cardCenterService.getBonusCount();
        } else {
          this.toast.show({ message: this.localService.getValue('hl_conf_f'), type: 'fail' });
          this.cardLoading = false;
        }
      });
  }

  /** 一键领取卡券 */
  onBatchCards() {
    this.collectAllLoading = true;
    this.bonusApi.onBatchReceiveBonus().subscribe(data => {
      if (data) {
        this.cardCenterService.getBonusCount();
        this.toast.show({ message: this.localService.getValue('coupon.get_succes'), type: 'success' });
      } else {
        this.toast.show({ message: this.localService.getValue('coupon.get_fail'), type: 'success' });
        this.collectAllLoading = false;
      }
    });
  }

  /**
   * 判断是否开启底部区域 Sticky 模式
   *
   * @param isVisible
   */
  onOpenStickyModule(isVisible: boolean) {
    this.btnSticky = !isVisible;
  }

  /**
   * 法幣虛擬貨幣切換
   *
   * @param index 0:法 1:虛
   * @returns
   */
  selectNoticeItemMenu(index: number) {
    if (this.selectNoticeItemIndex == index) {
      return;
    }
    this.selectNoticeItemIndex = index;
    this.setRightPage();
  }

  /**
   * 设置右侧显示的页面
   */
  setRightPage() {}

  /**
   * 选择通知类型菜单 根据 顶部2级通知分类菜单 重新获取
   *
   * @param i 下标index
   * @param item 当前选择类型数据
   * @returns
   */
  onSelectNoticeTypeMenuItem(item: any, i: number): void {
    //避免空数据下，进行无意义请求
    // if (this.allNotice.length == 0 && item.msg == 0) {
    //   return;
    // }
    this.noticeType = item.value;
    this.loadData();
  }

  /**@activeToolIdx toolTips 当前激活下标 */
  activeToolIdx: number = -1;
  onShowTool(idx: number) {
    this.activeToolIdx = idx;
  }

  /**
   * 获取通知数据
   */
  loadData() {
    this.noticeLoading = true;
    const params = {
      page: this.paginator.page,
      pageSize: this.paginator.pageSize,
      noticeType: this.noticeType,
      isReaded: this.isReaded,
    };
    //清空数据
    this.allNotice = [];
    this.notiPaginator = {
      page: 1,
      pageSize: 10,
      total: 0,
    };
    this.getNoticeMsg(false, params);
  }

  /***
   *根据 顶部【工具菜单】重新进行数据获取
   */
  onClickToolMeun(item: any, i: number) {
    switch (i) {
      case 0:
        this.onReadMsg();
        break;
      case 1:
        this.onDeleteMsg();
        break;
      default:
        break;
    }
  }

  /**
   * 隐藏已读信息
   */
  onHiddenReadedMsg(): void {
    if (!this.data.isHiddenReadedMsg) {
      this.isReaded = false;
      this.data.isHiddenReadedMsg = true;
    } else {
      this.isReaded = undefined;
      this.data.isHiddenReadedMsg = false;
    }
    this.allNotice = [];
    this.loadData();
  }

  /**
   * 清除已读
   */
  onDeleteMsg(): void {
    const params = {
      noticeType: this.noticeType,
    };
    this.noticeLoading = true;
    this.notificationApi
      .onDeleteAll(params)
      .pipe(
        finalize(() => {
          this.noticeLoading = false;
          this.loadData();
        }),
      )
      .subscribe(data => {
        if (data) {
          this.toast.show({ message: this.localService.getValue('noti_delete'), type: 'success' });
          this.notificationService.isDeleteAll$.next(data);
          this.notificationService.getNoticeCounts();
        } else {
          this.toast.show({ message: this.localService.getValue('noti_de_f'), type: 'fail' });
        }
      });
  }

  /**
   * _onKycPageClick
   *
   * @param e Event
   */
  private _onKycPageClick = (e: Event) => {
    e.preventDefault?.();
    e.stopPropagation?.();
    this.router.navigate([this.appService.languageCode, 'global-settings', 'account', 'kyc']);
  };
}
